export default __webpack_public_path__ + "static/media/icon_7.a23a10d3.png";